<section class="flex flex-col font-display">
  <span class="text-2xl font-bold sm:text-3xl">Resubmit Reimbursement</span>
  <form
    [formGroup]="form"
    class="grid grid-cols-1 gap-8 mt-6 p-4 text-sm lg:grid-cols-2"
  >
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span class="font-medium">Title</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            type="text"
            formControlName="title"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan judul"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('title')?.invalid && form.get('title')?.touched
            }"
          />
          <span
            *ngIf="form.get('title')?.invalid && form.get('title')?.touched"
            class="text-red-500 text-xs"
            >Title is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2">
        <span>Amount</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            formatNumber
            formatCurrency
            type="text"
            formControlName="amount"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan nominal"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('amount')?.invalid && form.get('amount')?.touched
            }"
          />
          <span
            *ngIf="form.get('amount')?.invalid && form.get('amount')?.touched"
            class="text-red-500 text-xs"
            >Amount is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2">
        <span>Currency</span>
        <div class="w-full flex flex-col space-y-1">
          <mat-select
            type="text"
            formControlName="currency"
            class="!w-full h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih mata uang"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('currency')?.invalid && form.get('currency')?.touched
            }"
          >
            <mat-option
              value="Rp"
              class="!font-display !text-sm !tracking-normal"
              >Rupiah</mat-option
            >
            <mat-option
              value="USD"
              class="!font-display !text-sm !tracking-normal"
              >US Dollar</mat-option
            >
            <mat-option
              value="SGD"
              class="!font-display !text-sm !tracking-normal"
              >Singapore Dollar</mat-option
            >
          </mat-select>
          <span
            *ngIf="
              form.get('currency')?.invalid && form.get('currency')?.touched
            "
            class="text-red-500 text-xs"
            >Currency is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span>Expense Category</span>
        <div class="w-full flex flex-col space-y-1">
          <mat-select
            type="text"
            formControlName="expanseCategoryId"
            class="!w-full h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih kategori expense"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('expanseCategoryId')?.invalid &&
                form.get('expanseCategoryId')?.touched
            }"
          >
            <ng-container *ngFor="let item of expenseCategory">
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
            </ng-container>
          </mat-select>
          <span
            *ngIf="
              form.get('expanseCategoryId')?.invalid &&
              form.get('expanseCategoryId')?.touched
            "
            class="text-red-500 text-xs"
            >Expense Category is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span class="font-medium">Receipt Date</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            type="date"
            formControlName="date"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Pilih tanggal kwitansi"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('date')?.invalid && form.get('date')?.touched
            }"
          />
          <span
            *ngIf="form.get('date')?.invalid && form.get('date')?.touched"
            class="text-red-500 text-xs"
            >Receipt Date is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span class="font-medium">Tag</span>
        <div class="w-full flex flex-col space-y-1">
          <mat-select
            type="text"
            formControlName="tagId"
            class="!w-full h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih tag"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('tagId')?.invalid && form.get('tagId')?.touched
            }"
          >
            <ng-container *ngFor="let item of tag">
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
            </ng-container>
          </mat-select>
          <span
            *ngIf="form.get('tagId')?.invalid && form.get('tagId')?.touched"
            class="text-red-500 text-xs"
            >Tag is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 mt-4 col-span-1 sm:col-span-2">
        <span class="font-medium">Description</span>
        <div class="w-full flex flex-col space-y-1">
          <textarea
            type="text"
            formControlName="description"
            class="w-full h-32 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan deskripsi"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('description')?.invalid &&
                form.get('description')?.touched
            }"
          ></textarea>
          <span
            *ngIf="
              form.get('description')?.invalid &&
              form.get('description')?.touched
            "
            class="text-red-500 text-xs"
            >Description is required</span
          >
        </div>
      </div>
      <div class="col-span-1 py-4 sm:col-span-2 sm:py-6">
        <mat-divider class="!border-gray-300"></mat-divider>
      </div>
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span class="font-medium">Select Location</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            type="text"
            formControlName="location"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan lokasi"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('location')?.invalid && form.get('location')?.touched
            }"
          />
          <span
            *ngIf="
              form.get('location')?.invalid && form.get('location')?.touched
            "
            class="text-red-500 text-xs"
            >Location is required</span
          >
        </div>
      </div>
      <div class="col-span-1 py-4 sm:col-span-2 sm:py-6">
        <mat-divider class="!border-gray-300"></mat-divider>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-8 sm:grid-cols-2">
      <div class="w-full flex flex-col space-y-2 sm:col-span-2 lg:col-span-1">
        <span class="font-medium">Attachment </span>
        <input
          type="file"
          #file
          name="file"
          class="hidden"
          multiple
          (change)="uploadFile($event)"
        />
        <div
          class="h-72 w-full max-w-xs rounded-lg border border-gray-200 flex flex-col items-center justify-center sm:h-80 sm:max-w-sm lg:h-96"
        >
          <i class="fa-solid fa-file text-6xl" *ngIf="!uploadStatus"></i>
          <mat-spinner [diameter]="50" *ngIf="uploadStatus"></mat-spinner>
          <span
            class="mt-2 text-xs break-words whitespace-normal text-center w-full px-2"
            *ngIf="fileExists && !uploadStatus"
            >{{ this.fileName }}</span
          >
        </div>
        <button
          type="button"
          class="w-full max-w-xs h-12 flex items-center justify-center rounded-lg border border-gray-400 sm:max-w-sm"
          (click)="file.click()"
        >
          {{ fileExists ? "Add More Files" : "Add File" }}
        </button>
        <div *ngIf="uploadedFiles.length" class="w-full max-w-xs sm:max-w-sm flex flex-col gap-2">
          <button
            *ngFor="let fileItem of uploadedFiles; let i = index"
            type="button"
            class="w-full h-12 flex items-center justify-between rounded-lg border border-gray-400 px-4"
            (click)="download(fileItem)"
          >
            <span class="inline-flex items-center gap-2 min-w-0">
              <i class="fa-solid fa-file text-[#1F9AA2]"></i>
              <span class="text-xs break-words text-left">{{
                fileItem.fileName ?? "Attachment"
              }}</span>
            </span>
            <span
              class="text-xs text-red-500"
              (click)="removeUploadedFile(i); $event.stopPropagation()"
              >Remove</span
            >
          </button>
        </div>
        <span class="text-xs w-full max-w-xs sm:max-w-sm"
          >Support file extension (jpg, png, jpeg, bmp, pdf, xls, xlsx, doc,
          docx)</span
        >
      </div>
      <div class="flex flex-col w-full" *ngIf="reimburseLogs.length">
        <ng-container *ngFor="let item of reimburseLogs; let i = index">
          <div class="flex items-start">
            <div class="flex flex-col items-center">
              <div
                class="w-10 h-10 rounded-full border-4 flex items-center justify-center"
                [ngClass]="{
                  'border-green-400': item.created_by == reimburse.created_by,
                  'border-blue-400': item.created_by != reimburse.created_by,
                  'border-orange-400':
                    item.created_by != reimburse.created_by &&
                    authService.isFinance(item.creator)
                }"
              >
                <img
                  [src]="item.creator?.imageUrl || 'profile.png'"
                  alt="Profile"
                  class="rounded-full w-full h-full object-cover"
                />
              </div>
              <div
                class="w-1 h-16"
                [ngClass]="{
                  'bg-green-400': item.created_by == reimburse.created_by,
                  'bg-blue-400': item.created_by != reimburse.created_by,
                  'bg-orange-400':
                    item.created_by != reimburse.created_by &&
                    authService.isFinance(item.creator)
                }"
                *ngIf="i != reimburseLogs.length - 1"
              ></div>
            </div>
            <div class="ml-4">
              <h3 class="font-bold text-black">
                {{ item.creator?.firstName }} {{ item.creator?.lastName }}
              </h3>
              <p class="text-gray-500">{{ item.description }}</p>
              <span class="text-sm text-gray-400" *ngIf="item.updated_at"
                >{{ item.updated_at | date : "fullDate" }}
                {{ item.updated_at | date : "HH:mm" : "+0700" }} WIB</span
              >
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="flex flex-col p-4">
    <span class="font-medium">History Approval</span>
    <div class="w-full overflow-x-auto">
      <table
        mat-table
        [dataSource]="approvalList"
        class="mat-elevation-z0 mt-6 min-w-max w-full"
      >
        <ng-container matColumnDef="user">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            User
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.user?.firstName }} {{ element.user?.lastName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="team">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            Team
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.user?.team?.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="sequence">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            Sequence
          </th>
          <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            Date
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.approve_at | date : "fullDate" }}
            {{ element.approve_at | date : "HH:mm" : "+0700" }} WIB
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            Status
          </th>
          <td mat-cell *matCellDef="let element">
            {{
              element.status == true
                ? "Approved"
                : element.status == false
                ? "Rejected"
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="notes">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            Notes
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.approval_note }}
          </td>
        </ng-container>

        <ng-container stickyEnd matColumnDef="action">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="!font-semibold text-lg whitespace-nowrap"
          >
            Action
          </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <button
              (click)="detail(element, i + 1)"
              class="flex items-center justify-center h-8 w-8 rounded-md bg-[#42A5CE] text-white"
            >
              <i class="fa-solid fa-eye"></i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div
              class="w-full flex flex-col items-center justify-center gap-2 py-6 text-center font-display"
            >
              <div
                class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400"
              >
                <i class="fa-solid fa-inbox"></i>
              </div>
              <span class="text-sm font-semibold text-slate-700"
                >No data available</span
              >
              <span class="text-xs text-slate-500"
                >Try adjusting filters or search.</span
              >
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div
    class="flex flex-col gap-3 mt-8 col-span-2 p-4 sm:flex-row sm:items-center"
  >
    <button
      (click)="resubmit()"
      class="w-full sm:w-72 h-12 rounded-lg bg-[#85E2B1] text-white flex items-center justify-center space-x-2"
    >
      <span>Re-Submit</span>
    </button>
    <button
      class="w-full sm:w-72 h-12 rounded-lg bg-[#FF6A65] text-white flex items-center justify-center space-x-2"
    >
      <span>Close Transaction</span>
    </button>
  </div>
</section>
